import { Suspense, lazy } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { PageLayout } from '~/components';
import CreateReport from './CreateReport';

const ReportDashboard = lazy(() => import('./ReportDashboard'));

export const AppRoutes = () => {
    return (
        <Suspense fallback={null}>
            <Routes>
                <Route
                    element={
                        <PageLayout>
                            <Outlet />
                        </PageLayout>
                    }
                >
                    <Route path="/" element={<ReportDashboard />} />
                    <Route path="/create-report" element={<CreateReport />} />
                </Route>
            </Routes>
        </Suspense>
    );
};
